<div [hidden]="!active" class="steps__content">
  <ng-content></ng-content>
</div>
